import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { HttpUtil, ApiResponse } from "@aa/common";

@Injectable({ providedIn: "root" })
export class PdfDownloadService {
  private readonly http = inject(HttpClient);

  // The server reconstructs the advice from {domain, adviceId} and renders the
  // PDF; no document body is sent (issue #346).
  public download(domain: string, adviceId: string): Observable<ApiResponse> {
    const url = `/api/selfserv/advice/${encodeURIComponent(domain)}/${encodeURIComponent(adviceId)}?format=pdf`;

    return this.http
      .request("GET", url, {
        responseType: "blob",
        observe: "response",
      })
      .pipe(
        map((res: HttpResponse<Blob>) => HttpUtil.parseBlobResponse(res)),
        catchError(HttpUtil.handleError),
      );
  }
}
